import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useRef, useState } from 'react';
import '../../CSS/Global.css';
import './ProductFormPage.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../SideBar';
import Header from '../Header';
import Select from 'react-select';
import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';
import ImageModalEquip from '../Modal/ImageModalProd';
import ImageModalDownloadable from '../Modal/ImageModalDownloadble';
import ImageModalGallery from '../Modal/ImageModalGallery';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { X, EyeOff, Eye, Trash2 } from 'lucide-react';
import { decryptToken } from '../utils/getToken';
import { getDiscountValidationError } from './productPricingValidation';
import { resolveBrandName } from './productSelectUtils';
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
    SortableContext,
    verticalListSortingStrategy,
    arrayMove
} from "@dnd-kit/sortable";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import SortableSpecItem from './SortableSpecItem';
import AIProductAssistant from './AIProductAssistant';
import ProductSeoFields from './ProductSeoFields';


function SortableKeyFeature({ feature, setFormData }) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: feature.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    return (
        <li
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}
            className="oms-tag-item"
        >
            {feature.text}

            <X
                type="button"
                className="oms-tag-delete"
                onClick={() => {
                    setFormData(prev => ({
                        ...prev,
                        key_features: prev.key_features.filter(
                            f => f.id !== feature.id
                        )
                    }));
                }}
                size={14}
            />
        </li>
    );
}

function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}


const generateUniqueSKU = (() => {
    const usedSKUs = new Set();

    return () => {
        let sku;
        do {
            sku = 'SKU-' + Math.random().toString(36).substring(2, 10).toUpperCase();
        } while (usedSKUs.has(sku));
        usedSKUs.add(sku);
        return sku;
    };
})();

const generateSKU9 = () => {
    const time = Date.now().toString(36).toUpperCase().slice(-5); // 5 chars
    const rand = Math.random().toString(36).toUpperCase().slice(2, 4); // 2 chars
    return `VP${time}${rand}`; // SM + 7 = 9 chars
};



const VariableProduct = () => {
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const [keyFeatureInput, setKeyFeatureInput] = useState('');
    const [specInput, setSpecInput] = useState({ label: '', value: '' });
    const [savedAttributeIds, setSavedAttributeIds] = useState([]);
    const [loading, setLoading] = useState(false);
    const token = decryptToken("accessToken") || ""
    const [formData, setFormData] = useState({
        image: [],
        gallery: [],
        title: '',
        product_type: { value: 'Variable Product', label: 'Variable Product' },
        category: null,
        categorytype: [],
        status: null,
        stock: { value: "Unlimited Stock", label: "Unlimited Stock" },
        typeofsimple: "",
        short_description: "",
        description: "",
        attribute: [],
        variation: [],
        user_id: user.main_id,
        user_name: user.full_name,
        delivery_days: "",
        key_features: [],
        specifications: [],
        meta_title: "",
        meta_description: "",
        meta_keywords: [],
        tags: [],
        faqs: [],
        category_id: "",
        categorytype_id: [],
        warranty: "Yes",
        warranty_from: "",
        warranty_note: "",
        brand_name: "",
        installation: "",
        installation_fee: "",
        brand_id: [],
        gst_type: "included",
        gst_percentage: "",
        hsn: "",
        discount_type: "price",
        discount_price: "",
        discount_percentage: "",
    });
    const [availableSizes] = useState(["XS", "S", "M", "L", "XL", "XXL"]);
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [variationsAccordion, setVariationsAccordion] = useState([]);
    const [showVariations, setShowVariations] = useState(false);
    const navigate = useNavigate();
    const [variationErrors, setVariationErrors] = useState({});


    const [activeIndex, setActiveIndex] = useState(null);
    const toggleAccordion = (index) => {
        setActiveIndex(prevIndex => (prevIndex === index ? null : index));
    };



    const searchListStyles = {
        container: {
            maxHeight: '250px',
            overflowY: 'auto',
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '10px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        },
        item: {
            display: 'flex',
            alignItems: 'center',
            padding: '10px',
            borderBottom: '1px solid #eee',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease',
        },
        itemHover: {
            backgroundColor: '#f8f9fa',
        },
        image: {
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            marginRight: '15px',
        },
        info: {
            display: 'flex',
            flexDirection: 'row',
            gap: "5px",
            alignItems: "center"
        },
        studentName: {
            fontWeight: '600',
            fontSize: '14px',
            marginBottom: '2px',
        },
        studentID: {
            fontSize: '12px',
            color: '#666',
        },
    };




    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [showImageModalGallery, setShowImageModalGallery] = useState(false);
    const [imagesGallery, setImagesGallery] = useState([]);
    const [categories, setCategories] = useState([]);
    const [brand, setBrand] = useState([]);

    const [isUploadModalOpen, setUploadModalOpen] = useState(false);


    const [variations, setVariations] = useState([]);
    const [variationDetails, setVariationDetails] = useState({});
    const [selectedImageVar, setSelectedImageVar] = useState(null); // For main product image
    const [showModalVar, setShowModalVar] = useState(false);
    const [showModalVar1, setShowModalVar1] = useState(false);
    const [imagesVar, setImagesVar] = useState([]);
    const [variationImages, setVariationImages] = useState({}); // Track selected images for each variation
    const [currentVariationId, setCurrentVariationId] = useState(null);
    const [variationGalleryImages, setVariationGalleryImages] = useState({});
    const [selectedAttributes, setSelectedAttributes] = useState([]);
    const [accordionsState, setAccordionsState] = useState({});
    const [attribute, setAttribute] = useState([]);
    const [filteredAttribute, setFilteredAttribute] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const url = API_BASE_URL

    const handleOpenModalVar = (variationId) => {
        setCurrentVariationId(variationId); // Set the variation ID
        setShowModalVar(true); // Open the modal
    };

    const handleCloseModalVar = () => {
        setShowModalVar(false);
    };

    const handleImageView = async () => {
        const all = await axios.get(`${url}/api/images/${user.main_id}`);
        setImages((all.data).reverse());
    }


    const fetchCategories = async () => {
        try {
            const response = await fetch(`${url}/category/getdata/category/${user.main_id}`, {
                method: "GET",
            });
            const res = await response.json();

            const options = res.map(cat => ({
                value: cat.id,
                label: cat.category || cat.category || "Unnamed Category",
                id: cat.id
            }));

            // Add the dummy "Select" option at the top
            const withDummy = [{ value: "", label: "Select" }, ...options];

            setCategories(withDummy);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchBrand = async () => {
        try {
            const response = await fetch(`${url}/brand/getall`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const res = await response.json();

            const options = res.data.map(cat => ({
                value: cat.id,
                label: cat.name || cat.name || "Unnamed Category",
                id: cat.id
            }));

            // Add the dummy "Select" option at the top


            setBrand(options);
        } catch (error) {
            console.error(error);
        }
    };

    // console.log("✅ Submitting valid form data:", formData);
    const updateTypeofCat = (key, isChecked) => {
        let updatedTypes = [...formData.categorytype];

        if (isChecked) {
            if (!updatedTypes.includes(key)) updatedTypes.push(key);
        } else {
            updatedTypes = updatedTypes.filter(type => type !== key);
        }

        setFormData((prev) => ({
            ...prev,
            categorytype: updatedTypes
        }));
    };

    const updateTypeofWar = (key, isChecked) => {
        let updatedTypes = [...formData.warranty];

        if (isChecked) {
            updatedTypes = [key]; // allow only one selection
        } else {
            updatedTypes = []; // none selected if unchecked
        }

        setFormData((prev) => ({
            ...prev,
            warranty: updatedTypes
        }));
    };

    const updateTypeofWarfrom = (key, isChecked) => {
        let updatedTypes = [...formData.warranty_from];

        if (isChecked) {
            updatedTypes = [key]; // allow only one selection
        } else {
            updatedTypes = []; // none selected if unchecked
        }

        setFormData((prev) => ({
            ...prev,
            warranty_from: updatedTypes
        }));
    };


    const updateTypeofInstall = (key, isChecked) => {
        let updatedTypes = [];

        if (isChecked) {
            updatedTypes = [key]; // allow only one selection
        } else {
            updatedTypes = []; // none selected if unchecked
        }

        setFormData((prev) => ({
            ...prev,
            installation: updatedTypes,
        }));
    };




    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];
    const [genrte, setGenerate] = useState(false)





    const StockOptions = [
        { value: 'In stock', label: 'In stock' },
        { value: 'Out of stock', label: 'Out of stock' },
        { value: 'Unlimited Stock', label: 'Unlimited Stock' },
    ];

    const handleChange1 = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({ ...prev, [id]: value }));
    };

    const handleSelectChange = (selectedOption, { name }) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,              // keeps {value: "Electronics", label: "Electronics", id: 5}
            category_id: selectedOption?.id || "" // 👈 stores actual id
        }));
    };


    const handleSelectChangeBrand = (selectedOption, { name }) => {
        setFormData((prev) => ({
            ...prev,
            [name]: selectedOption,               // keep label+value for UI
            brand_id: selectedOption?.value || "", // keep value for backend
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.title === "" || formData.title === null) {
            toast.error("Title is required")
            return;
        }
        try {
            const existingRes = await axios.get(
                `${url}/grouped-product/search-all-products/${encodeURIComponent(user.main_id)}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const existingProducts = Array.isArray(existingRes.data) ? existingRes.data : [];
            const nameExists = existingProducts.some(
                (p) => p.title?.trim().toLowerCase() === formData.title.trim().toLowerCase()
            );
            if (nameExists) {
                toast.warning("Product name already exists. Please use a different name.", {
                    position: "top-center",
                    autoClose: 3000
                });
                return;
            }
        } catch (err) {
            console.error("Name check failed:", err);
        }
        let hasError = false;
        let firstErrorIndex = -1;
        let firstErrorMessage = "";

        variations.forEach((variation, index) => {
            const details = variationDetails[variation.id] || {};
            const regularPrice = parseFloat(details.price || 0);
            const salePrice = parseFloat(details.salePrice || 0);
            const discountErr = getDiscountValidationError(details, regularPrice, {
                baseLabel: "regular price",
            });
            const variationLabel =
                Object.values(variation.attributes).join(" & ") || `Variation #${index + 1}`;

            if (discountErr) {
                hasError = true;
                if (firstErrorIndex === -1) {
                    firstErrorIndex = index;
                    firstErrorMessage = `${discountErr} (${variationLabel})`;
                }
            } else if (!isNaN(salePrice) && !isNaN(regularPrice) && salePrice > regularPrice) {
                hasError = true;
                if (firstErrorIndex === -1) {
                    firstErrorIndex = index;
                    firstErrorMessage = `Sale price cannot be greater than regular price. (${variationLabel})`;
                }
            }
        });

        if (hasError) {
            toast.error(firstErrorMessage);
            setActiveIndex(firstErrorIndex);
            return;
        }


        try {
            const payload = {
                ...formData,
                warranty: Array.isArray(formData.warranty)
                    ? formData.warranty[0] || ""
                    : formData.warranty,

                warranty_from: Array.isArray(formData.warranty_from)
                    ? formData.warranty_from[0] || ""
                    : formData.warranty_from,

                installation: Array.isArray(formData.installation)
                    ? formData.installation[0] || ""
                    : formData.installation,
                image: formData.image[0]?.url || "",
                product_type: formData.product_type?.value || "", // ✅ Convert to string
                status: formData.status?.value || "",
                stock: formData.stock?.value || "",
                categorytype: Array.isArray(formData.categorytype)
                    ? formData.categorytype.join(',')
                    : formData.categorytype,
                category: formData.category?.value || "",
                category_id: formData.category?.value || "",
                user_id: user.main_id,
                user_name: user.full_name,
                variation: variations,
                brand_name: resolveBrandName(formData.brand_name),
                // warranty_from: formData.warranty_from[0] || "",
                // installation: formData.installation[0] || "",
                gst_type: formData.gst_type,
                gst_percentage: formData.gst_type === "excluded" ? formData.gst_percentage : null,
            };

            const response = await fetch(`${url}/variable-product/admin1997`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload)
            });
            const res = await response.json();
            if (response.ok) {
                navigate("/products")
                toast.success("Product added successfully", {
                    position: "top-center",
                    autoClose: 2000
                });
                console.log("Product submitted successfully");
            } else {
                toast.warning(res.message)
                console.error("Failed to submit product");
            }

        } catch (error) {
            console.error("Submission error:", error);
        }
    };





    const handleNavigate = (url) => {
        navigate(url)
    };


    const fetchDataAttribute = async () => {
        try {
            const response = await fetch(`${url}/attribute/getdata/${user.main_id}`)
            const res = await response.json();
            ;
            setAttribute(res);
        } catch (error) {
            console.error(error);
        }
    }

    const handleSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        // console.log(query);
        if (query === '') {
            // If search query is empty, show all attributes
            setFilteredAttribute(attribute);
        } else {
            // If there is a search query, filter based on it
            const filtered = attribute.filter((attr) =>
                attr.name.toLowerCase().includes(query.toLowerCase())
            );
            setFilteredAttribute(filtered);
        }
    };

    const handleAttributeClick = (attribute) => {
        // Add the selected attribute to the selectedAttributes array
        setSelectedAttributes((prev) => [
            ...prev,
            { ...attribute, selectedTerms: [] },
        ]);
        setSearchQuery('');
        setFilteredAttribute([]);
        setAccordionsState((prevState) => ({
            ...prevState,
            [attribute.name]: true, // Open this accordion initially
        }));
    };

    const handleSelectAll = (e, attribute) => {
        e.preventDefault(); // ⛔ Prevent page reload
        const updatedAttributes = selectedAttributes.map((attr) =>
            attr.id === attribute.id
                ? { ...attr, selectedTerms: [...attr.associatedTerms] }
                : attr
        );
        setFormData({
            ...formData,
            attribute: updatedAttributes
        });
        setSelectedAttributes(updatedAttributes);
    };


    const handleDeselectAll = (e, attribute) => {
        e.preventDefault();
        const updatedAttributes = selectedAttributes.map((attr) =>
            attr.id === attribute.id
                ? { ...attr, selectedTerms: [] }
                : attr
        );
        setFormData({
            ...formData,
            attribute: updatedAttributes
        })
        setSelectedAttributes(updatedAttributes);
    };

    const toggleAttributeAccordion = (attrName) => {
        setAccordionsState((prev) => ({
            ...prev,
            [attrName]: !prev[attrName],
        }));
    };


    const handleTermClick = (attribute, term) => {
        const updatedAttributes = selectedAttributes.map((attr) => {
            if (attr.id === attribute.id) {
                const isSelected = attr.selectedTerms.includes(term);
                const updatedTerms = isSelected
                    ? attr.selectedTerms.filter((t) => t.id !== term.id)
                    : [...attr.selectedTerms, term];
                return { ...attr, selectedTerms: updatedTerms };
            }
            return attr;
        });
        setFormData({
            ...formData,
            attribute: updatedAttributes
        })
        setSelectedAttributes(updatedAttributes);
    };


    const handleVariationImageSelect = (variationId, image) => {
        if (!image?.url) {
            console.error("Invalid image:", image);
            return;
        }

        setVariations((prevVariations) =>
            prevVariations.map((variation) =>
                variation.id === variationId
                    ? { ...variation, imageUrl: image.url }
                    : variation
            )
        );

        setFormData((prevEquipment) => ({
            ...prevEquipment,
            variation: prevEquipment.variation.map((variation) =>
                variation.id === variationId
                    ? { ...variation, imageUrl: image.url }
                    : variation
            ),
        }));

        setVariationImages((prevImages) => ({
            ...prevImages,
            [variationId]: image, // Store the selected image per variation
        }));

        setShowModalVar(false);
    };

    const handleVariationGallerySelect = (variationId, images) => {
        if (!Array.isArray(images) || images.length === 0) {
            console.error("Invalid images:", images);
            return;
        }

        setVariationGalleryImages((prevImages) => {
            const existingImages = prevImages[variationId] || [];

            // Filter out duplicate images
            const uniqueNewImages = images.filter(
                (img) => !existingImages.some((existing) => existing.url === img.url)
            );

            return {
                ...prevImages,
                [variationId]: [...existingImages, ...uniqueNewImages], // Append unique images only
            };
        });

        setVariations((prevVariations) =>
            prevVariations.map((variation) =>
                variation.id === variationId
                    ? {
                        ...variation,
                        galleryImages: [
                            ...(variation.galleryImages || []),
                            ...images
                                .map((img) => img.url)
                                .filter((url) => !(variation.galleryImages || []).includes(url)), // Avoid duplicates
                        ],
                    }
                    : variation
            )
        );

        setFormData((prevEquipment) => ({
            ...prevEquipment,
            variation: prevEquipment.variation.map((variation) =>
                variation.id === variationId
                    ? {
                        ...variation,
                        galleryImages: [
                            ...(variation.galleryImages || []),
                            ...images
                                .map((img) => img.url)
                                .filter((url) => !(variation.galleryImages || []).includes(url)), // Avoid duplicates
                        ],
                    }
                    : variation
            ),
        }));

        setShowModalVar1(false);
    };


    const handleRemoveGalleryImage = (variationId, index) => {
        setVariationGalleryImages((prevImages) => {
            if (!Array.isArray(prevImages[variationId])) return prevImages;

            const updatedImages = [...prevImages[variationId]];
            updatedImages.splice(index, 1);

            return { ...prevImages, [variationId]: updatedImages };
        });

        setVariations((prevVariations) =>
            prevVariations.map((variation) =>
                variation.id === variationId
                    ? { ...variation, galleryImages: variation.galleryImages.filter((_, i) => i !== index) }
                    : variation
            )
        );

        setFormData((prevEquipment) => ({
            ...prevEquipment,
            variation: prevEquipment.variation.map((variation) =>
                variation.id === variationId
                    ? { ...variation, galleryImages: variation.galleryImages.filter((_, i) => i !== index) }
                    : variation
            ),
        }));
    };



    // Handle removing variation images
    const handleRemoveVariationImage = (variationId) => {
        setVariationImages((prevImages) => {
            const updatedImages = { ...prevImages };
            delete updatedImages[variationId];
            return updatedImages;
        });
    };
    // Utility function to generate random 6-character ID
    const generateRandomId = () => {
        return Math.random().toString(36).substr(2, 6);
    };

    // const handleVariationDetailChange = (id, field, value) => {
    //     // Ensure sale price is not greater than regular price
    //     const updatedDetails = {
    //         ...variationDetails[id],
    //         [field]: value
    //     };

    //     const regularPrice = parseFloat(field === "price" ? value : updatedDetails.price);
    //     const salePrice = parseFloat(field === "salePrice" ? value : updatedDetails.salePrice);

    //     const newErrors = { ...variationErrors };

    //     if (!isNaN(salePrice) && !isNaN(regularPrice) && salePrice > regularPrice) {
    //         newErrors[id] = "Sale price cannot be higher than regular price.";
    //     } else {
    //         delete newErrors[id];
    //     }

    //     setVariationErrors(newErrors);

    //     // Update the main formData properly
    //     setFormData((prev) => ({
    //         ...prev,
    //         variation: prev.variation.map((variation) => {
    //             if (variation.id === id) {
    //                 return {
    //                     ...variation,           // preserve existing attributes and galleryImages
    //                     price: field === 'price' ? value : variation.price,
    //                     salePrice: field === 'salePrice' ? value : variation.salePrice,
    //                     sku: field === 'sku' ? value : variation.sku,
    //                     stock: field === 'stock' ? value : variation.stock
    //                 };
    //             }
    //             return variation;
    //         })
    //     }));


    //     // Update local variations state
    //     setVariations((prevVariations) =>
    //         prevVariations.map((variation) =>
    //             variation.id === id ? { ...variation, [field]: value } : variation
    //         )
    //     );

    //     // Update variation details state
    //     setVariationDetails((prevState) => ({
    //         ...prevState,
    //         [id]: updatedDetails
    //     }));
    // };

    const handleVariationDetailChange = (id, field, value) => {

        const updatedDetails = {
            ...variationDetails[id],
            [field]: value
        };

        let regularPrice = parseFloat(
            field === "price" ? value : updatedDetails.price
        ) || 0;

        let salePrice = parseFloat(updatedDetails.salePrice) || 0;

        const discountType = updatedDetails.discount_type || "price";
        const discountPrice = parseFloat(updatedDetails.discount_price) || 0;
        const discountPercentage = parseFloat(updatedDetails.discount_percentage) || 0;

        // 🔹 Auto calculate sale price
        if (regularPrice > 0) {

            if (discountType === "price") {
                salePrice = regularPrice - discountPrice;
            }

            if (discountType === "percentage") {
                salePrice = regularPrice - (regularPrice * discountPercentage) / 100;
            }

            if (salePrice < 0) salePrice = 0;

            updatedDetails.salePrice = salePrice.toFixed(2);
        }

        // Update formData
        setFormData((prev) => ({
            ...prev,
            variation: prev.variation.map((variation) => {
                if (variation.id === id) {
                    return {
                        ...variation,
                        price: updatedDetails.price,
                        title:updatedDetails.title,
                        salePrice: updatedDetails.salePrice,
                        sku: updatedDetails.sku || variation.sku,
                        stock: updatedDetails.stock || variation.stock,
                        discount_type: updatedDetails.discount_type,
                        discount_price: updatedDetails.discount_price,
                        discount_percentage: updatedDetails.discount_percentage
                    };
                }
                return variation;
            })
        }));


        // Update variations state
        setVariations((prevVariations) =>
            prevVariations.map((variation) =>
                variation.id === id
                    ? { ...variation, ...updatedDetails }
                    : variation
            )
        );


        // Update variationDetails state
        setVariationDetails((prevState) => ({
            ...prevState,
            [id]: updatedDetails
        }));
    };

    const cartesianProduct = (arrays) => {
        return arrays.reduce((acc, curr) => {
            return acc.flatMap(a => curr.map(c => [...a, c]));
        }, [[]]);
    };


    const getAttributeName = (attrId) => {
        const attr = attribute.find(a => a.id === attrId);
        return attr ? attr.name : 'Unknown';
    };

    const getTermName = (attrId, termId) => {
        const attr = attribute.find(a => a.id === attrId);
        if (!attr) return 'N/A';
        const term = attr.associatedTerms.find(t => t.id === termId);
        return term ? term.name : 'N/A';
    };


    const handleGenerateVariations = (e) => {
        e.preventDefault();

        const termArrays = selectedAttributes.map(attr =>
            attr.selectedTerms.map(term => ({ attrId: attr.id, termId: term.id }))
        );

        const combinations = cartesianProduct(termArrays); // utility to get all combos

        const newVariations = combinations.map((combo, idx) => ({
            id: `v${idx}${Date.now()}`,
            attributes: Object.fromEntries(combo.map(item => [item.attrId, item.termId])),
            price: 0,
            salePrice: 0,
            title:'',
            sku: generateSKU9(),

            stock: 0
        }));

        setVariations(newVariations);
    };





    const handleRemoveVariation = (id) => {
        setVariations(variations.filter(variation => variation.id !== id));
    };

    const handleDeleteAttribute = (attributeId) => {
        // Filter out the attribute with the given id
        const updatedAttributes = selectedAttributes.filter((attribute) => attribute.id !== attributeId);

        // Update the state with the filtered attributes
        setSelectedAttributes(updatedAttributes);
        setFormData({
            ...formData,
            attribute: updatedAttributes
        })

        // Optionally, if you're saving the changes to the backend, you can also call an API to delete the attribute here
        // await axios.delete(`${url}/api/attributes/${attributeId}`);
    };

    const handleSaveAttributes = (e, attribute) => {
        e.preventDefault();

        // Save only IDs
        const updatedAttributes = selectedAttributes.map(attr => ({
            id: attr.id,
            selectedTermIds: attr.selectedTerms.map(term => term.id)
        }));

        // Update attributes in formData
        setFormData(prev => {
            // Generate variations immediately after saving attributes
            const newVariations = generateVariations(updatedAttributes);

            return {
                ...prev,
                attribute: updatedAttributes,
                variation: newVariations
            };
        });

        setSavedAttributeIds(prev => [...prev, attribute.id]);
    };


    const generateVariations = (attributes) => {
        if (!attributes || attributes.length === 0) return [];

        // Start with an array with a single empty variation
        let result = [{}];

        attributes.forEach(attr => {
            const { id: attrId, selectedTermIds } = attr;

            const temp = [];
            result.forEach(variation => {
                selectedTermIds.forEach(termId => {
                    temp.push({
                        ...variation,
                        attributes: {
                            ...variation.attributes,
                            [attrId]: termId
                        }
                    });
                });
            });

            result = temp;
        });

        return result;
    };


    useEffect(() => {
        fetchDataAttribute();
        handleImageView();
        fetchCategories();
        fetchBrand();
    }, [])


    return (
        <>

            <div className="product-form-page">
                <div className="oms-header product-form-page__header">
                    <div className="product-form-page__title-wrap">
                        <h1 className="dashboard-title">Variable Product</h1>
                        <p className="product-form-page__subtitle">
                            Set attributes and variations; pricing updates from MRP and discount rules.
                        </p>
                    </div>
                    {
                        loading ?
                            <button type="button" className="oms-add-btn">
                                Publishing...
                            </button> : <button type="button" onClick={handleSubmit} className="oms-add-btn">
                                Publish
                            </button>
                    }


                </div>
                <form className="oms-modal-form property-form product-form-page__form"
                    onSubmit={handleSubmit}
                >


                    <div className='oms-givepaddingfrom'>

                        {/* AI Product Assistant (isolated AI layer — content only) */}
                        <AIProductAssistant
                            productType="variable"
                            onApply={(patch) =>
                                setFormData((prev) => ({ ...prev, ...patch }))
                            }
                        />

                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Name
                            </label>
                            <input
                                type="text"
                                id="title"
                                placeholder="Enter title"
                                value={formData.title}
                                onChange={handleChange1}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Short  Description
                            </label>
                            <ReactQuill
                                theme="snow"
                                value={formData.short_description}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, short_description: value }))
                                }
                                placeholder="Enter Short Description"
                            />
                        </div>


                        <div className="oms-form-group">
                            <label htmlFor="description" className="oms-form-label">
                                Description
                            </label>
                            <div className="product-form-page__quill">
                                <ReactQuill
                                    theme="snow"
                                    value={formData.description}
                                    onChange={(value) =>
                                        setFormData((prev) => ({ ...prev, description: value }))
                                    }
                                    placeholder="Enter Description"
                                />
                            </div>
                        </div>

                        {/* Product Image Upload */}
                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Image</label>

                            {/* Button to open image modal */}
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModal(true)}
                            >
                                Choose Image
                            </button>


                            {/* Preview selected image */}
                            {formData.image.length > 0 && (
                                <div className="selected-image-preview">
                                    <img
                                        src={formData.image[0]?.url ? `${url}${formData.image[0].url}` : formData.image[0]}
                                        alt="Selected"
                                    />
                                    <p
                                        className='delete-btnomsprod'
                                        onClick={() => setFormData((prev) => ({ ...prev, image: [] }))}

                                    >
                                        <i className="fa-solid fa-xmark" aria-hidden />
                                    </p>
                                </div>
                            )}
                        </div>

                        <ImageModalEquip
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            onImageSelect={(img) =>
                                setFormData((prev) => ({ ...prev, image: [img] }))
                            }
                            multiple={false}
                            setImages={setImages}
                        />

                        <div className="oms-form-group">
                            <label className="oms-form-label">Product Gallery</label>
                            <button
                                type="button"
                                className="image-upload-btn"
                                onClick={() => setShowImageModalGallery(true)}
                            >
                                Add Gallery Images
                            </button>

                            {/* Preview selected gallery images */}
                            <div className="gallery-preview">
                                {formData.gallery.map((img, index) => (
                                    <div key={index} className="product-form-page__gallery-item">
                                        <img
                                            src={img?.url ? `${url}${img.url}` : img}
                                            alt="gallery"
                                            className='gallery-preview-image'
                                        // style={{ width: "80px", height: "80px", objectFit: "cover", border: "1px solid #ccc" }}
                                        />
                                        <p
                                            type="button"
                                            className='delete-btnomsprod'
                                            onClick={() => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    gallery: prev.gallery.filter((_, i) => i !== index)
                                                }));
                                            }}

                                        >
                                            <i className="fa-solid fa-xmark" aria-hidden />
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <ImageModalGallery
                            show={showImageModalGallery}
                            handleClose={() => setShowImageModalGallery(false)}
                            images={images}
                            multiple={true} // ⬅️ set to true for gallery
                            setImages={setImages}
                            onImageSelect={(imgs) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    gallery: Array.isArray(imgs) ? [...prev.gallery, ...imgs] : [...prev.gallery, imgs]
                                }));
                            }}
                        />

                        <div className="oms-form-group oms-attr-form-group">
                            <label className="oms-form-label oms-attr-form-label">Select Attributes</label>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={handleSearch}
                                placeholder="Enter attribute (e.g., Color, Size)"
                                className="oms-attr-search-input"
                            />
                            {filteredAttribute.length > 0 && (
                                <div style={searchListStyles.container} className="oms-attr-search-dropdown">
                                    {filteredAttribute.map((attr) => (
                                        <div
                                            key={attr.id}
                                            style={searchListStyles.item}
                                            className="oms-attr-search-item"
                                            onClick={() => handleAttributeClick(attr)}
                                        >
                                            <span style={searchListStyles.studentName} className="oms-attr-search-name">{attr.name}</span>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {selectedAttributes.map((attribute) => (
                                <div key={attribute.id} className="accordion mt-3 oms-attr-accordion">
                                    <div className="accordianinside oms-attr-accordion-inner">
                                        <h5 className="attributenamedisplay oms-attr-title">{attribute.name}</h5>
                                        <div className="attributecloseexpand oms-attr-controls">
                                            <span
                                                className="oms-attr-expand-btn toggle-icon-btn"
                                                onClick={() => toggleAttributeAccordion(attribute.name)}
                                            >
                                                {accordionsState[attribute.name] ? <EyeOff size={22} /> : <Eye size={22} />}
                                            </span>

                                            <span
                                                className="oms-attr-delete-btn"
                                                onClick={() => handleDeleteAttribute(attribute.id)}
                                            >
                                                <Trash2 size={22} />
                                            </span>
                                        </div>
                                    </div>

                                    {accordionsState[attribute.name] && (
                                        <div className="valuewatch oms-attr-value-box">
                                            <p>Value(s):</p>
                                            <div className="term-selection oms-attr-term-list">
                                                {attribute.associatedTerms.map((term) => (
                                                    <span
                                                        key={term.id}
                                                        className={`term-item oms-attr-term-item ${attribute.selectedTerms.includes(term) ? 'selected' : ''}`}
                                                        onClick={() => handleTermClick(attribute, term)}
                                                    >
                                                        {term.name}
                                                    </span>
                                                ))}
                                            </div>
                                            <div className="threebuttontogether mt-3 oms-attr-actions">
                                                {attribute.associatedTerms.length > 0 && (
                                                    <>
                                                        {attribute.selectedTerms.length < attribute.associatedTerms.length ? (
                                                            <button
                                                                type="button"
                                                                className="me-2 oms-attr-btn-selectall"
                                                                onClick={(e) => handleSelectAll(e, attribute)}
                                                            >
                                                                Select all
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type="button"
                                                                className="me-2 oms-attr-btn-deselectall"
                                                                onClick={(e) => handleDeselectAll(e, attribute)}
                                                            >
                                                                Select none
                                                            </button>
                                                        )}
                                                    </>
                                                )}

                                                <button
                                                    type="button"
                                                    className="oms-attr-btn-save"
                                                    onClick={(e) => handleSaveAttributes(e, attribute)}
                                                >
                                                    Save attributes
                                                </button>
                                            </div>

                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="variation-wrapper oms-attr-variation-wrapper">
                            {/* {selectedAttributes.length > 0 && selectedAttributes.every(attr => attr.selectedTerms.length > 0) && (
                                <button
                                    type="button"
                                    className="btn-generate oms-attr-generate-btn"
                                    onClick={(e) => handleGenerateVariations(e)}
                                >
                                    Generate Variations
                                </button>
                            )} */}

                            {/* <div className="variation-wrapper oms-attr-variation-wrapper"> */}
                            {selectedAttributes.length > 0 &&
                                savedAttributeIds.length === selectedAttributes.length && (
                                    <button
                                        type="button"
                                        className="btn-generate oms-attr-generate-btn"
                                        onClick={(e) => handleGenerateVariations(e)}
                                    >
                                        Generate Variations
                                    </button>
                                )}
                            {/* </div> */}


                            {variations.length > 0 && (
                                <div className="accordion-list oms-attr-variation-list">
                                    {variations.map((variation, index) => (
                                        <div className="accordion-item oms-attr-variation-item" key={variation.id}>
                                            <div
                                                className="accordion-header oms-attr-variation-header"
                                                onClick={() => toggleAccordion(index)}
                                            >
                                                <div className="accordion-title oms-attr-variation-title">
                                                    <strong>#{variation.id}</strong> - {
                                                        Object.entries(variation.attributes)
                                                            .map(([attrId, termId]) => {
                                                                const attribute = selectedAttributes.find(a => a.id === Number(attrId));
                                                                const term = attribute?.associatedTerms.find(t => t.id === Number(termId));
                                                                return `${attribute?.name || 'Unknown'}: ${term?.name || 'N/A'}`;
                                                            })
                                                            .join(' & ')
                                                    }
                                                </div>
                                                <span
                                                    className="remove-btn oms-attr-remove-variation-btn"
                                                    onClick={(e) => { e.stopPropagation(); handleRemoveVariation(variation.id); }}
                                                >
                                                    Remove
                                                </span>
                                            </div>

                                            {activeIndex === index && (
                                                <div className="accordion-body oms-attr-variation-body">
                                                   
                                                    <div className="form-row oms-attr-pricing-row">
                                                        <div className="form-group oms-attr-stock-group">
                                                            <label>Title:</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Title"
                                                                value={variationDetails[variation.id]?.title || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'title', e.target.value)}
                                                                // onWheel={(e) => e.target.blur()}
                                                            />
                                                        </div>
                                                        <div className="form-group oms-attr-price-group">
                                                            <label>Regular Price:</label>
                                                            <input
                                                                type="number"
                                                                placeholder="Price"
                                                                value={variationDetails[variation.id]?.price || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'price', e.target.value)}
                                                                onWheel={(e) => e.target.blur()}
                                                            />
                                                        </div>


                                                        <div className="form-group">
                                                            <label>Discount Type</label>

                                                            <div className="oms-checkbox-group">

                                                                <div className="oms-checkbox-item">
                                                                    <input
                                                                        type="radio"
                                                                        name={`discount_type_${variation.id}`}
                                                                        checked={(variationDetails[variation.id]?.discount_type || "price") === "price"}
                                                                        onChange={() =>
                                                                            handleVariationDetailChange(variation.id, "discount_type", "price")
                                                                        }
                                                                    />
                                                                    <label>Price</label>
                                                                </div>

                                                                <div className="oms-checkbox-item">
                                                                    <input
                                                                        type="radio"
                                                                        name={`discount_type_${variation.id}`}
                                                                        checked={variationDetails[variation.id]?.discount_type === "percentage"}
                                                                        onChange={() =>
                                                                            handleVariationDetailChange(variation.id, "discount_type", "percentage")
                                                                        }
                                                                    />
                                                                    <label>Percentage</label>
                                                                </div>

                                                            </div>
                                                        </div>

                                                        {(variationDetails[variation.id]?.discount_type || "price") === "price" && (
                                                            <div className="form-group">
                                                                <label>Discount Price</label>
                                                                <input
                                                                    type="number"
                                                                    placeholder="Enter discount price"
                                                                    value={variationDetails[variation.id]?.discount_price || ""}
                                                                    onChange={(e) =>
                                                                        handleVariationDetailChange(
                                                                            variation.id,
                                                                            "discount_price",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    onWheel={(e) => e.target.blur()}
                                                                />
                                                            </div>
                                                        )}

                                                        {variationDetails[variation.id]?.discount_type === "percentage" && (
                                                            <div className="form-group">
                                                                <label>Discount Percentage (%)</label>
                                                                <input
                                                                    type="number"
                                                                    placeholder="Enter discount percentage"
                                                                    value={variationDetails[variation.id]?.discount_percentage || ""}
                                                                    onChange={(e) =>
                                                                        handleVariationDetailChange(
                                                                            variation.id,
                                                                            "discount_percentage",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    onWheel={(e) => e.target.blur()}
                                                                />
                                                            </div>
                                                        )}
                                                        <div className="form-group oms-attr-saleprice-group">
                                                            <label>Sale Price:</label>
                                                            <input
                                                                type="number"
                                                                placeholder="Sale Price"
                                                                value={variationDetails[variation.id]?.salePrice || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'salePrice', e.target.value)}
                                                                onWheel={(e) => e.target.blur()}
                                                                readOnly
                                                                style={{ borderColor: variationErrors[variation.id] ? 'red' : undefined }}
                                                            />
                                                            {variationErrors[variation.id] && (
                                                                <div style={{ color: 'red', fontSize: '12px' }}>
                                                                    {variationErrors[variation.id]}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="form-group oms-attr-sku-group">
                                                            <label>SKU:</label>
                                                            <input
                                                                type="text"
                                                                placeholder="SKU"
                                                                value={(variationDetails[variation.id]?.sku || variation.sku)?.toUpperCase()}
                                                                onChange={(e) =>
                                                                    handleVariationDetailChange(variation.id, 'sku', e.target.value.toUpperCase())
                                                                }
                                                            />
                                                        </div>

                                                        <div className="form-group oms-attr-stock-group">
                                                            <label>Stock:</label>
                                                            <input
                                                                type="number"
                                                                placeholder="Stock"
                                                                value={variationDetails[variation.id]?.stock || ''}
                                                                onChange={(e) => handleVariationDetailChange(variation.id, 'stock', e.target.value)}
                                                                onWheel={(e) => e.target.blur()}
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Variation Image */}
                                                    <div className="form-group oms-attr-img-group">
                                                        <label>Product Image</label>
                                                        {!variationImages[variation.id] ? (
                                                            <input
                                                                type="text"
                                                                readOnly
                                                                placeholder="Choose image"
                                                                onClick={() => handleOpenModalVar(variation.id)}
                                                                className="oms-attr-img-input"
                                                            />
                                                        ) : (
                                                            <div className="image-preview oms-attr-img-preview">
                                                                <img
                                                                    src={`${url}${variationImages[variation.id]?.url}`}
                                                                    alt="Selected"
                                                                    width={100}
                                                                    height={100}
                                                                    onClick={() => handleOpenModalVar(variation.id)}
                                                                />
                                                                <p
                                                                    className="remove-link oms-attr-img-remove"
                                                                    onClick={() => handleRemoveVariationImage(variation.id)}
                                                                >
                                                                    Remove product image
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="form-group">
                                                        <label>Product Gallery</label>
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            placeholder="Choose gallery"
                                                            // onClick={() => setShowModalVar1(true)}
                                                            onClick={() => {
                                                                setCurrentVariationId(variation.id); // ✅ set correct ID
                                                                setShowModalVar1(true);
                                                            }}

                                                        // onClick={() => handleOpenModalVar1(variation.id)}
                                                        />
                                                        <div className="gallery-preview">
                                                            {Array.isArray(variationGalleryImages[variation.id]) && variationGalleryImages[variation.id].map((img, idx) => (
                                                                <div key={idx} className="gallery-img">
                                                                    <img
                                                                        src={`${url}${img.url}`}
                                                                        alt="Gallery"
                                                                        width={80}
                                                                        height={80}
                                                                    // onClick={() => handleOpenModalVar1(variation.id)}
                                                                    />
                                                                    <p
                                                                        type='button'
                                                                        className="delete-btnomsprod"
                                                                        onClick={() => handleRemoveGalleryImage(variation.id, idx)}
                                                                    >
                                                                        <i className="fa-solid fa-xmark"></i>
                                                                    </p>
                                                                </div>
                                                            ))}

                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}


                            <ImageModalEquip
                                show={showModalVar}
                                handleClose={handleCloseModalVar}
                                images={images}
                                onImageSelect={(image) => handleVariationImageSelect(currentVariationId, image)}
                                multiple={false}
                                setImages={setImages}
                            />
                            <ImageModalGallery
                                show={showModalVar1}
                                handleClose={() => setShowModalVar1(false)}
                                images={images}
                                onImageSelect={(imgs) => handleVariationGallerySelect(currentVariationId, imgs)}
                                multiple={true}
                                setImages={setImages}
                            />
                        </div>


                        <div className="oms-form-group">
                            <label htmlFor="status" className="oms-form-label">
                                Stock Status
                            </label>
                            <Select
                                options={StockOptions}
                                placeholder="Select Stock Status"
                                name="stock"
                                value={formData.stock}
                                onChange={handleSelectChange}
                            />
                        </div>



                        {/* Key Features */}
                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Key Features</label>
                            <div className="product-form-page__field-row">
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Enter key feature"
                                    value={keyFeatureInput}
                                    onChange={(e) => setKeyFeatureInput(e.target.value)}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (keyFeatureInput.trim()) {
                                            setFormData(prev => ({
                                                ...prev,
                                                key_features: [
                                                    ...prev.key_features,
                                                    {
                                                        id: crypto.randomUUID(),
                                                        text: keyFeatureInput.trim()
                                                    }
                                                ]
                                            }));

                                            setKeyFeatureInput("");
                                        }
                                    }}
                                >
                                    Add More
                                </button>
                            </div>
                            <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={({ active, over }) => {
                                    if (!over) return;

                                    if (active.id !== over.id) {
                                        const oldIndex = formData.key_features.findIndex(
                                            item => item.id === active.id
                                        );

                                        const newIndex = formData.key_features.findIndex(
                                            item => item.id === over.id
                                        );

                                        const reordered = arrayMove(
                                            formData.key_features,
                                            oldIndex,
                                            newIndex
                                        );

                                        setFormData(prev => ({
                                            ...prev,
                                            key_features: reordered
                                        }));
                                    }
                                }}
                            >
                                <SortableContext
                                    items={formData.key_features.map(f => f.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <ul className="oms-tag-list">
                                        {formData.key_features.map(feature => (
                                            <SortableKeyFeature
                                                key={feature.id}
                                                feature={feature}
                                                setFormData={setFormData}
                                            />
                                        ))}
                                    </ul>
                                </SortableContext>
                            </DndContext>
                        </div>

                        {/* Specifications */}
                        <div className="oms-form-group ome-form-button2">
                            <label className="oms-form-label">Specifications</label>
                            <div className="product-form-page__spec-tools">
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Label"
                                    value={specInput.label}
                                    onChange={(e) => setSpecInput((prev) => ({ ...prev, label: e.target.value }))}
                                />
                                <input
                                    type="text"
                                    className="oms-input"
                                    placeholder="Value"
                                    value={specInput.value}
                                    onChange={(e) => setSpecInput((prev) => ({ ...prev, value: e.target.value }))}
                                />
                                <button
                                    type="button"
                                    className="oms-add-btn"
                                    onClick={() => {
                                        if (specInput.label.trim() && specInput.value.trim()) {
                                            setFormData((prev) => ({
                                                ...prev,
                                                specifications: [
                                                    ...prev.specifications,
                                                    { id: crypto.randomUUID(), label: specInput.label, value: specInput.value }
                                                ],
                                            }));
                                            setSpecInput({ label: '', value: '' });
                                        }
                                    }}
                                >
                                    Add More
                                </button>
                            </div>

                            <DndContext
                                collisionDetection={closestCenter}
                                onDragEnd={({ active, over }) => {
                                    if (!over) return;
                                    if (active.id !== over.id) {
                                        const oldIndex = formData.specifications.findIndex(s => s.id === active.id);
                                        const newIndex = formData.specifications.findIndex(s => s.id === over.id);

                                        const reordered = arrayMove(formData.specifications, oldIndex, newIndex);

                                        setFormData(prev => ({
                                            ...prev,
                                            specifications: reordered
                                        }));
                                    }
                                }}
                            >
                                <SortableContext
                                    items={formData.specifications.map(s => s.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <ul className="oms-tag-list">
                                        {formData.specifications.map((spec) => (
                                            <SortableSpecItem
                                                key={spec.id}
                                                spec={spec}
                                                setFormData={setFormData}
                                            />
                                        ))}
                                    </ul>
                                </SortableContext>
                            </DndContext>
                        </div>
                        {/* SEO / Tags / FAQs (AI-populated, editable, content-only) */}
                        <ProductSeoFields formData={formData} setFormData={setFormData} />

                        {/* Category */}
                        <div className="oms-form-group">
                            <label htmlFor="category" className="oms-form-label">
                                Category
                            </label>
                            <Select
                                options={categories}
                                placeholder="Select category"
                                name="category"
                                value={formData.category}
                                onChange={handleSelectChange}
                                isClearable
                            />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="brand_name" className="oms-form-label">
                                Brand
                            </label>
                            <Select
                                options={brand}
                                placeholder="Select brand"
                                name="brand_name"
                                value={formData.brand_name}
                                onChange={handleSelectChangeBrand}
                                isClearable
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Choose Home Category</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Best Sellers"
                                        checked={formData.categorytype.includes("Best Sellers")}
                                        onChange={(e) => updateTypeofCat("Best Sellers", e.target.checked)}
                                    />
                                    <label htmlFor="Best Sellers">Best Sellers</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Trending"
                                        checked={formData.categorytype.includes("Trending")}
                                        onChange={(e) => updateTypeofCat("Trending", e.target.checked)}
                                    />

                                    <label htmlFor="Trending">Trending</label>
                                </div>
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Warranty</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Yes"
                                        checked={formData.warranty.includes("Yes")}
                                        onChange={(e) => updateTypeofWar("Yes", e.target.checked)}
                                    />
                                    <label htmlFor="Yes">Yes</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="No"
                                        checked={formData.warranty.includes("No")}
                                        onChange={(e) => updateTypeofWar("No", e.target.checked)}
                                    />

                                    <label htmlFor="No">No</label>
                                </div>
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Warranty From</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Us"
                                        checked={formData.warranty_from.includes("Us")}
                                        onChange={(e) => updateTypeofWarfrom("Us", e.target.checked)}
                                    />
                                    <label htmlFor="Us">Us</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Company"
                                        checked={formData.warranty_from.includes("Company")}
                                        onChange={(e) => updateTypeofWarfrom("Company", e.target.checked)}
                                    />

                                    <label htmlFor="Company">Company</label>
                                </div>
                            </div>
                        </div>

                        <div className="oms-form-group">
                            <label htmlFor="warranty_note" className="oms-form-label">
                                Warranty note
                            </label>
                            <div className="product-form-page__quill">
                                <ReactQuill
                                    theme="snow"
                                    value={formData.warranty_note}
                                    onChange={(value) =>
                                        setFormData((prev) => ({ ...prev, warranty_note: value }))
                                    }
                                    placeholder="Enter Warranty Note"
                                />
                            </div>
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">Installation</label>
                            <div className="oms-checkbox-group">
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Free Installation"
                                        checked={formData.installation.includes("Free Installation")}
                                        onChange={(e) => updateTypeofInstall("Free Installation", e.target.checked)}
                                    />
                                    <label htmlFor="Free Installation">Free Installation</label>
                                </div>
                                <div className="oms-checkbox-item">
                                    <input
                                        type="checkbox"
                                        id="Paid Installation"
                                        checked={formData.installation.includes("Paid Installation")}
                                        onChange={(e) => updateTypeofInstall("Paid Installation", e.target.checked)}
                                    />
                                    <label htmlFor="Paid Installation">Paid Installation</label>
                                </div>
                            </div>
                        </div>

                        {
                            formData?.installation[0] === "Paid Installation" &&
                            <div className="oms-form-group">
                                <label htmlFor="installation_fee" className="oms-form-label">
                                    Installation Fee
                                </label>
                                <input
                                    type="number"
                                    id="installation_fee"
                                    placeholder="Enter Installation Fee"
                                    value={formData.installation_fee}
                                    onChange={handleChange1}
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        }
                        <div className="oms-form-group">
                            <label htmlFor="delivery_days" className="oms-form-label">
                                Delivery Days
                            </label>
                            <input
                                type="number"
                                id="delivery_days"
                                placeholder="Enter Delivery within days"
                                value={formData.delivery_days}
                                onChange={handleChange1}
                                onWheel={(e) => e.target.blur()}
                            />
                        </div>
                        <div className="oms-form-group">
                            <label className="oms-form-label">GST Type</label>

                            <div className="oms-checkbox-group">
                                {/* Included GST */}
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="gst_included"
                                        name="gst_type"
                                        checked={formData.gst_type === "included"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                gst_type: "included",
                                                gst_percentage: "" // clear gst %
                                            }))
                                        }
                                    />
                                    <label htmlFor="gst_included">Included GST</label>
                                </div>

                                {/* Excluded GST */}
                                <div className="oms-checkbox-item">
                                    <input
                                        type="radio"
                                        id="gst_excluded"
                                        name="gst_type"
                                        checked={formData.gst_type === "excluded"}
                                        onChange={() =>
                                            setFormData(prev => ({
                                                ...prev,
                                                gst_type: "excluded"
                                            }))
                                        }
                                    />
                                    <label htmlFor="gst_excluded">Excluded GST</label>
                                </div>
                            </div>
                        </div>

                        {/* GST Percentage - show only when excluded */}
                        {formData.gst_type === "excluded" && (
                            <div className="oms-form-group">
                                <label className="oms-form-label">GST Percentage (%)</label>
                                <input
                                    type="number"
                                    placeholder="Enter GST percentage e.g. 18"
                                    value={formData.gst_percentage}
                                    onChange={(e) =>
                                        setFormData(prev => ({
                                            ...prev,
                                            gst_percentage: e.target.value
                                        }))
                                    }
                                    onWheel={(e) => e.target.blur()}
                                />
                            </div>
                        )}
                        <div className="oms-form-group">
                            <label htmlFor="hsn" className="oms-form-label">
                                HSN CODE
                            </label>
                            <input
                                type="text"
                                id="hsn"
                                placeholder="Enter HSN CODE"
                                value={formData.hsn}
                                onChange={handleChange1}
                            />
                        </div>

                        {/* Status */}
                        <div className="oms-form-group">
                            <label htmlFor="status" className="oms-form-label">
                                Status
                            </label>
                            <Select
                                options={statusOptions}
                                placeholder="Select status"
                                name="status"
                                value={formData.status}
                                onChange={handleSelectChange}
                            />
                        </div>

                        {/* Actions */}


                        <div className="oms-form-actions">
                            {
                                loading ? <button type="button" className='post-property-submit'>Publishing...</button>
                                    : <button type="submit" className='post-property-submit'>Publish</button>
                            }

                        </div>
                    </div>

                </form >
            </div >
        </>
    );
};

export default VariableProduct;


const DownloadableFiles = () => {
    const [files, setFiles] = useState([{ name: '', url: '', file: null }]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [images, setImages] = useState([]);

    const handleAddFile = () => {
        setFiles([...files, { name: '', url: '', file: null }]);
    };

    const handleRemoveFile = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
    };

    const handleChange = (index, field, value) => {
        const updatedFiles = [...files];
        updatedFiles[index][field] = value;
        setFiles(updatedFiles);
    };

    return (
        <div className="downloadable-section">
            {/* <h4>Downloadable files</h4> */}
            <div className="file-input-table">
                {files.map((file, index) => (
                    <div className="file-row" key={index}>
                        <input
                            type="text"
                            placeholder="File name"
                            value={file.name}
                            onChange={(e) => handleChange(index, 'name', e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="http://"
                            value={file.url}
                            onChange={(e) => handleChange(index, 'url', e.target.value)}
                        />
                        <button
                            type="button"
                            className="upload-tab-button"
                            onClick={() => setShowImageModal(true)}
                        >
                            Choose file
                        </button>
                        <input
                            id={`fileInput-${index}`}
                            type="file"
                            style={{ display: 'none' }}
                            onChange={(e) => handleChange(index, 'file', e.target.files[0])}
                        />
                        <button
                            type="button"
                            className="remove-btn"
                            onClick={() => handleRemoveFile(index)}
                        >
                            <i className="fa-solid fa-xmark" aria-hidden />
                        </button>
                        <ImageModalDownloadable
                            show={showImageModal}
                            handleClose={() => setShowImageModal(false)}
                            images={images}
                            // onImageSelect={(img) =>
                            //     setFormData((prev) => ({ ...prev, image: [img] }))
                            // }
                            multiple={false}
                            setImages={setImages}
                        />
                    </div>
                ))}
                <button className="add-btn" type="button" onClick={handleAddFile}>
                    Add File
                </button>
            </div>
        </div>
    );
};




{/* <div className="property-dropdown-wrapper">
                                            <button className="oms-add-btn" onClick={() => setIsOpen(!isOpen)}>
                                                Add Products
                                            </button>
                                            {isOpen && (
                                                <ul className="property-dropdown-menu">
                                                    <li onClick={() => handleNavigate('/simple-product')}>
                                                        Simple Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/grouped-product')}>
                                                        Grouped Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/grouped-product')}>
                                                        Grouped Product
                                                    </li>
                                                    <li onClick={() => handleNavigate('/external-affiliate-product')}>
                                                        Affiliate Product
                                                    </li> 
                                                    <li onClick={() => handleNavigate('/variable-product')}>
                                                        Variable Product
                                                    </li>
                                                </ul>
                                            )}
                                        </div> */}